import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const forwarderSimulatorContract = c.router({
  authenticate: {
    method: 'POST',
    path: '/simulator/forwarder-api/authenticate',
    body: z.object({
      email: z.string(),
      password: z.string(),
    }),
    responses: {
      200: z.object({
        token: z.string(),
        expirationTime: z.number(),
      }),
    },
  },

  syncBatch: {
    method: 'GET',
    path: '/simulator/forwarder-api/sync-batch/:batchId',
    pathParams: z.object({
      batchId: z.string(),
    }),
    responses: {
      200: z.object({
        data: z.object({
          declarations: z.array(z.any()),
        }),
      }),
    },
  },

  getCustomsReport: {
    method: 'GET',
    path: '/simulator/forwarder-api/get-customs-report/:batchId',
    pathParams: z.object({
      batchId: z.string(),
    }),
    responses: {
      200: z.any(),
    },
  },

  transferBatch: {
    method: 'POST',
    path: '/simulator/forwarder-api/transfer-batch',
    body: z.any(),
    responses: {
      200: z.any(),
    },
  },
});
